module.exports =  {
                    MERGE_CODE: "MERGE_CODE",
                    MERGE_CODE_RESULT: "MERGE_CODE_RESULT",
                    MERGE_CODE_ERROR: "MERGE_CODE_ERROR",
                    MERGE_CODE_INITIATED: "MERGE_CODE_INITIATED",
                    MERGE_CODE_CANCELLED: "MERGE_CODE_CANCELLED"
                  }
